import { Dialog, DialogContent, Grid2 } from "@mui/material";
import Top from "./Components/Top";
import Picker from "./Components/Picker/Picker";
import Bottom from "./Components/Bottom";
import useUIBp from "../../Hooks/useUIBoilerplate";
import { UIactions } from "../../store/slices/UI";

const GroupsTravelerModal = () => {
  const { dispatch, UI } = useUIBp();
  const { payload } = UI.modal2 ?? {};
  const { hideGroup } = payload ?? {};

  const onClose = (e, reason) => {
    if (reason !== "backdropClick") {
      dispatch(UIactions.closeModal2());
    }
  };

  const close = () => {
    dispatch(UIactions.closeModal2());
  };

  return (
    <Dialog
      fullWidth
      {...{
        open: true,
        onClose,
        maxWidth: "md",
        sx:{ zIndex: 1400 }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Grid2 container {...{ sx: { width: "100%" } }}>
          <Top {...{ close }} />
          <Picker {...{ hideGroup }} />
          <Bottom {...{ close }} />
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default GroupsTravelerModal;
